import { BrowserModule } from '@angular/platform-browser';
import { enableProdMode, Injector, NgModule, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';

import { SharedModule } from './shared/shared.module';
import { UserModule } from './user/user.module';
import { EventModule } from './event/event.module';

import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { RouteNotFoundComponent } from './shared/route-not-found/route-not-found.component';
import { AppMenuComponent } from './menus/app-menu/app-menu.component';
import { EventMenuComponent } from './menus/event-menu/event-menu.component';
import { NavigationModule } from './navigation/navigation.module';
import { MenuStore } from './menus/service/menu.store';
import { Angulartics2Module, Angulartics2GoogleAnalytics } from 'angulartics2';
import { VersionComponent } from './shared/version/version.component';
import { EventSearchFilterComponent } from './menus/event-search-filter/event-search-filter.component';
import { TranslateModule } from './ng2-translate.config';
import { HttpClientModule } from '@angular/common/http';
import { AppAuthHttpService } from './http/app.auth.http.service';
import { AllowApiDocsGuard } from './shared/guards/allow-api-docs.guard';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SlicePipe } from '@angular/common';
import { PaymentModule } from './payment/payment.module';
import { LayoutService } from './services/layout.service';
import { PioneerValidators } from './shared/utils/pioneer.validators';

const routes: Routes = [
  {path: 'version', component: VersionComponent},
  {path: '**', component: RouteNotFoundComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    AppMenuComponent,
    EventMenuComponent,
    EventSearchFilterComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule,
    AuthModule,
    EventModule,
    NavigationModule,
    UserModule,
    SharedModule,
    TranslateModule,
    HttpClientModule,
    // enable HashLocationStrategy
    // https://angular.io/docs/ts/latest/guide/router.html#!#browser-url-styles
    RouterModule.forRoot(routes, {useHash: true}),
    Angulartics2Module.forRoot([Angulartics2GoogleAnalytics]),
    NgxSpinnerModule,
    PaymentModule,
  ],
  providers: [
    MenuStore,
    AppAuthHttpService,
    SlicePipe,
    LayoutService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    PioneerValidators.injector = this.injector;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/app.module.ts